// extracted by mini-css-extract-plugin
export var root = "PaymentOptions-module--root--5cd42";